/**
 * 查新任务步骤
 */
export enum FtoTaskStep {
    /**
     * 初始状态, 新任务
     * @description 任务初始状态，任务没有创建，任务在服务端没有记录。
     * * 下一个状态（步骤）是 {@link FtoTaskStep.SUMMARY_START} 或 {@link FtoTaskStep.TECH_FEATURE_PULL_START}
     */
    INITIAL = '',
    /**
     * 总结用户输入为技术要点状态（步骤）
     * @description 这是一个【**客户端状态**】. 处于 {@link FtoTaskStep.INITIAL} 状态时，任务创建成功后，如果用户输入字符长度超过 2000 字符，则进入这个状态（步骤）。
     * 这个状态（步骤）展示 summary loading 过程, summary 拉取成功后，会自动进入 {@link FtoTaskStep.SUMMARY_END} 状态（步骤）。
     * * 上一个状态（步骤）是 {@link FtoTaskStep.INITIAL}
     * * 下一个状态（步骤）是 {@link FtoTaskStep.SUMMARY_END}
     */
    SUMMARY_START = 'SUMMARY_START',
    /**
     * 总结用户输入为技术要点结束状态（步骤）
     * @description 这是一个【**客户端状态**】. {@link FtoTaskStep.SUMMARY_START} 状态（步骤）结束后，自动进入这个状态（步骤）。
     * * 上一个状态（步骤）是 {@link FtoTaskStep.SUMMARY_START}
     * * 下一个状态（步骤）是 {@link FtoTaskStep.FTO_SEARCH_INPUT} 或 {@link FtoTaskStep.TECH_FEATURE_PULL_START}
     */
    SUMMARY_END = 'SUMMARY_END',
    /**
     * 任务已经提交，但未成功提取特征状态（步骤）
     * @description 任务创建成功后，特征提取成功前，任务达到的状态（步骤）。
     * * 上一个状态（步骤）是 {@link FtoTaskStep.SUMMARY_END}
     * * 下一个状态（步骤）是 {@link FtoTaskStep.TECH_FEATURE_PULL_START}
     */
    FTO_SEARCH_INPUT = 'FTO_SEARCH_INPUT',
    /**
     * 技术特征识别开始状态（步骤）
     * @description 这是一个【**客户端状态**】.
     * * 上一个状态（步骤）是 {@link FtoTaskStep.FTO_SEARCH_INPUT} 或 {@link FtoTaskStep.TECH_FEATURE_PULL_START}
     *     * 处于 {@link FtoTaskStep.INITIAL} 状态时，任务创建成功后，如果用户输入字符长度没有超过 2000 字符，则进入这个状态（步骤）
     *     * 处于 {@link FtoTaskStep.FTO_SEARCH_INPUT} 状态时，用户点击【下一步】按钮后，也会进入这个状态（步骤）。
     * * 下一个状态（步骤）是 {@link FtoTaskStep.TECH_FEATURE_PULL_SUCCESS} 或 {@link FtoTaskStep.FTO_SEARCH_INPUT}
     *     * 如果特征提取成功，会自动进入 {@link FtoTaskStep.TECH_FEATURE_PULL_SUCCESS} 状态（步骤）
     *     * 如果特征提取失败，会自动进入 {@link FtoTaskStep.FTO_SEARCH_INPUT} 状态（步骤）
     */
    TECH_FEATURE_PULL_START = 'FTO_SEARCH_TECH_FEATURE_START',
    /**
     * 技术特征识别结束状态（步骤）
     * @description 查新技术特征识别成功后，任务达到的状态（步骤）
     * * 上一个状态（步骤）是 {@link FtoTaskStep.TECH_FEATURE_PULL_START}
     * * 下一个状态（步骤）是 {@link FtoTaskStep.SEARCH_END}
     */
    TECH_FEATURE_PULL_SUCCESS = 'FTO_SEARCH_TECH_FEATURE',
    /**
     * 检索完成状态（步骤）
     * @description 检索完成，达到的状态（步骤）
     * * 上一个状态（步骤）是 {@link FtoTaskStep.TECH_FEATURE_PULL_SUCCESS}
     * * 下一个状态（步骤）是 {@link FtoTaskStep.REPORT_CREATED}
     */
    SEARCH_END = 'CONFIRM',
    /**
     * 报告生成结束
     * @description 报告生成成功后，达到的状态（步骤）
     * * 上一个状态（步骤）是 {@link FtoTaskStep.SEARCH_END}
     */
    REPORT_CREATED = 'RESULT',
}

/**
 * 专利风险等级枚举
 */
export enum PatentRiskLevel {
    HIGH = 'High',
    MEDIUM = 'Medium',
    LOW = 'Low',
}

/**
 * 权利要求类型枚举
 */
export enum ClaimType {
    INDEPENDENT = 'independent',
    DEPENDENT = 'dependent',
}
